export enum PointProcessType {
  Manual = 0,
  OnEndDate = 1,
  OnAnswer = 2
}
